module.exports = __webpack_public_path__ + "media/images/redrock/hero-image-corona-f2c207928f647d6578cc5b1be7d37dc3.jpeg";